module.exports = __webpack_public_path__ + "public/img/tiku_cbg3.9ae4e2ff.png";